import React, { useState } from "react";
import EditContactInfo from "./EditContactInfo";
import { contactInfoTypeLabel } from "./contact_info_types";

// A single contact-info row — read mode shows the type and value with edit + remove controls; edit
// mode swaps in the row editor. Mirrors the publications editor's line component.
function EditContactInfoLine({ contactInfo, onChange, onRemove, disabled = false }) {
  const [editing, setEditing] = useState(false);

  const toggleEditing = () => {
    setEditing((prev) => !prev);
  };

  const confirmEditing = (updatedContactInfo) => {
    setEditing(false);
    onChange(updatedContactInfo);
  };

  return editing ? (
    <EditContactInfo
      contactInfo={contactInfo}
      onConfirm={confirmEditing}
      onCancel={toggleEditing}
      disabled={disabled}
    />
  ) : (
    <tr>
      <td>{contactInfoTypeLabel(contactInfo.type)}</td>
      <td className="text-break">{contactInfo.value}</td>
      <td className="text-nowrap">
        <div className="d-flex">
          <button
            onClick={toggleEditing}
            type="button"
            className="btn btn-sm btn-outline-primary d-flex"
            aria-label="Edit"
            disabled={disabled}
          >
            <i className="fas fa-edit" />
          </button>
          &nbsp;
          <button
            onClick={onRemove}
            type="button"
            className="btn btn-sm btn-outline-secondary d-flex"
            aria-label="Remove"
            disabled={disabled}
          >
            <i className="fas fa-trash text-destructive-90" />
          </button>
        </div>
      </td>
    </tr>
  );
}

export default EditContactInfoLine;
